import React, { useEffect, useState } from 'react';
import { SAPopover } from '../popover';
import { SAAlert } from '../alert';
export function SASnackbar(_a) {
    var autoHideDuration = _a.autoHideDuration, background = _a.background, children = _a.children, closeable = _a.closeable, icon = _a.icon, offset = _a.offset, onClose = _a.onClose, open = _a.open, position = _a.position, subtitle = _a.subtitle, title = _a.title, variant = _a.variant, zIndex = _a.zIndex;
    var _b = useState(null), referenceElement = _b[0], setReferenceElement = _b[1];
    function getX() {
        switch (position) {
            case 'top-start':
            case 'left':
            case 'bottom-start':
                return 0;
            case 'top-end':
            case 'right':
            case 'bottom-end':
                return document.documentElement.clientWidth;
            case 'top':
            case 'bottom':
            default:
                return document.documentElement.clientWidth / 2;
        }
    }
    function getY() {
        switch (position) {
            case 'top-start':
            case 'top':
            case 'top-end':
                return 0;
            case 'left':
            case 'right':
                return document.documentElement.clientHeight / 2;
            case 'bottom-start':
            case 'bottom':
            case 'bottom-end':
            default:
                return document.documentElement.clientHeight;
        }
    }
    function generateGetBoundingClientRect(x, y) {
        return function () { return ({
            width: 0,
            height: 0,
            top: y,
            right: x,
            bottom: y,
            left: x,
        }); };
    }
    function getSeverity() {
        switch (true) {
            case variant.includes('success'):
                return 'success';
            case variant.includes('info'):
                return 'info';
            case variant.includes('warning'):
                return 'warning';
            case variant.includes('error'):
                return 'error';
            case variant.includes('note'):
            default:
                return 'success';
        }
    }
    function getColor() {
        switch (true) {
            case variant.includes('success'):
                return 'success';
            case variant.includes('info'):
                return 'info';
            case variant.includes('warning'):
                return 'warning';
            case variant.includes('error'):
                return 'error';
            case variant.includes('note'):
            default:
                return 'blueGray600';
        }
    }
    function getIcon() {
        switch (true) {
            case variant.includes('note'):
                return 'information';
            default:
                return null;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function handleClose(event) {
        setReferenceElement(null);
        if (onClose) {
            onClose(event);
        }
    }
    var x = getX();
    var y = getY();
    var virtualElement = {
        getBoundingClientRect: generateGetBoundingClientRect(x, y),
    };
    // eslint-disable-next-line consistent-return
    function getContent() {
        if (variant.includes('custom')) {
            return children;
        }
        var severity = getSeverity();
        var color = getColor();
        var snackbarIcon = icon !== null ? icon : getIcon();
        if (snackbarIcon !== null && title !== null) {
            return (React.createElement(SAAlert, { severity: severity, color: color, icon: snackbarIcon, title: title, closeable: closeable, onClose: handleClose },
                subtitle && subtitle,
                children && children));
        }
        if (snackbarIcon !== null && title === null) {
            return (React.createElement(SAAlert, { severity: severity, color: color, icon: snackbarIcon, closeable: closeable, onClose: handleClose },
                subtitle && subtitle,
                children && children));
        }
        if (snackbarIcon === null && title !== null) {
            return (React.createElement(SAAlert, { severity: severity, color: color, title: title, closeable: closeable, onClose: handleClose },
                subtitle && subtitle,
                children && children));
        }
        return (React.createElement(SAAlert, { severity: severity, color: color, closeable: closeable, onClose: handleClose },
            subtitle && subtitle,
            children && children));
    }
    var popoverContent = getContent();
    useEffect(function () {
        function close() {
            setReferenceElement(null);
            if (onClose) {
                onClose();
            }
        }
        var timer;
        if (open) {
            setReferenceElement(virtualElement);
            if (autoHideDuration) {
                timer = setTimeout(function () {
                    close();
                }, autoHideDuration);
            }
        }
        else {
            close();
        }
        return function () { return clearTimeout(timer); };
    }, [open]);
    return (React.createElement(SAPopover, { background: background, offset: offset, onClose: handleClose, placement: position, referenceElement: referenceElement, variant: "popover-snackbar", zIndex: zIndex }, popoverContent));
}
SASnackbar.defaultProps = {
    autoHideDuration: null,
    background: 'rgba(0, 0, 0, 0)',
    children: null,
    closeable: null,
    icon: null,
    offset: [0, 0],
    onClose: null,
    position: 'bottom',
    subtitle: null,
    title: null,
    zIndex: 1400,
};
//# sourceMappingURL=snackbar.component.js.map